export const version = "bytes/5.8.0";
//# sourceMappingURL=_version.js.map